import { Base } from '../../../models/base.model';
import { PageObject } from '../../../models/page-object.model';
import { alias, deserialize, object, optional, serializable } from 'serializr';
import { Integration, IntegrationStatus } from '../enums/integration.enum';
import { ExternalApplicationMetaData } from './external-application-meta-data.model';
import jiraLogo from '@images/jira.svg';
import trelloLogo from '@images/trello.svg';
import clickupLogo from '@images/clickup.svg';
import mondayLogo from '@images/monday.svg';
import youtrackLogo from '@images/youtrack.svg';
import backlogLogo from '@images/backlog.svg';
import linearLogo from '@images/linear.svg';
import azureDevopsLogo from '@images/azure-devops.svg';
import bugzillaLogo from '@images/bugzilla.svg';
import mantisLogo from '@images/mantis.svg';
import testRailLogo from '@images/testrail.svg';
import qtestLogo from '@images/qtest.svg';
import gitlabLogo from '@images/gitlab-icon.svg';

export class ExternalApplicationConfig extends Base implements PageObject {
  @serializable
  public declare id: number;
  @serializable
  public name: string;
  @serializable
  public username: string;
  @serializable
  public password: string;
  @serializable
  public token: string;
  @serializable
  public application: Integration;
  @serializable
  public status: IntegrationStatus;
  @serializable
  public application_id: number;
  @serializable
  public url: string;
  @serializable(
    alias('metadata', optional(object(ExternalApplicationMetaData))),
  )
  public metaData: ExternalApplicationMetaData;
  @serializable
  public isAssetsPushEnabled;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ExternalApplicationConfig, input));
  }

  get isMantis(): boolean {
    return this.application == Integration.Mantis;
  }

  get checkMetaData(): ExternalApplicationMetaData {
    return this.metaData;
  }

  get isJira(): boolean {
    return this.application == Integration.Jira;
  }

  get isJiraServer(): boolean {
    return this.application == Integration.JiraServer;
  }

  get isXray(): boolean {
    return this.application == Integration.XrayCloud;
  }

  get isXrayServer(): boolean {
    return this.application == Integration.XrayServer;
  }

  get isAzure(): boolean {
    return this.application == Integration.Azure;
  }

  get isYoutrack(): boolean {
    return this.application == Integration.Youtrack;
  }

  get isBugzilla(): boolean {
    return this.application == Integration.BugZilla;
  }

  get isFreshrelease(): boolean {
    return this.application == Integration.Freshrelease;
  }

  get isSauceLabs(): boolean {
    return this.application == Integration.SauceLabs;
  }

  get isPrivateGrid(): boolean {
    return this.application == Integration.PrivateGrid;
  }

  get isLambdaTest(): boolean {
    return this.application == Integration.LambdaTest;
  }

  get isBrowserStack(): boolean {
    return this.application == Integration.BrowserStack;
  }

  get isKobiton(): boolean {
    return this.application == Integration.Kobiton;
  }

  get isSlack(): boolean {
    return this.application == Integration.Slack;
  }

  get isMSTeam(): boolean {
    return this.application == Integration.MS_Teams_Connector;
  }

  get isBackLog(): boolean {
    return this.application == Integration.BackLog;
  }

  get isGoogleChat(): boolean {
    return this.application == Integration.GoogleChat;
  }

  get isTrello(): boolean {
    return this.application == Integration.Trello;
  }

  get isLinear(): boolean {
    return this.application == Integration.Linear;
  }

  get isClickUp(): boolean {
    return this.application == Integration.ClickUp;
  }

  get isMonday(): boolean {
    if (this.application == Integration.Monday) this.name = 'Monday.com';
    return this.application == Integration.Monday;
  }

  get isTestRail(): boolean {
    return this.application == Integration.TestRail;
  }

  get isQTest(): boolean {
    return this.application == Integration.QTest;
  }

  get isZephyr(): boolean {
    return this.application == Integration.ZephyrCloud;
  }
  get isGitLab(): boolean {
    return this.application == Integration.GitLab;
  }

  get iconUrl() {
    let imgLoc = null;
    if (this.isJira) {
      imgLoc = jiraLogo;
    } else if (this.isJiraServer) {
      imgLoc = jiraLogo;
    } else if (this.isTrello) {
      imgLoc = trelloLogo;
    } else if (this.isClickUp) {
      imgLoc = clickupLogo;
    } else if (this.isMonday) {
      imgLoc = mondayLogo;
    } else if (this.isYoutrack) {
      imgLoc = youtrackLogo;
    } else if (this.isBackLog) {
      imgLoc = backlogLogo;
    } else if (this.isLinear) {
      imgLoc = linearLogo;
    } else if (this.isAzure) {
      imgLoc = azureDevopsLogo;
    } else if (this.isBugzilla) {
      imgLoc = bugzillaLogo;
    } else if (this.isMantis) {
      imgLoc = mantisLogo;
    } else if (this.isTestRail) {
      imgLoc = testRailLogo;
    } else if (this.isQTest) {
      imgLoc = qtestLogo;
    } else if (this.isGitLab) {
      imgLoc = gitlabLogo;
    }

    return imgLoc;
  }
}
